import { component } from 'picoapp'
import $ from 'quantdom'
import { resizeImageSrc } from '../lib/utils'

export default component((node) => {
  $(node).on('mouseover', (e) => {
    if ($(node).find('video').el() && !$(node).find('video').attr('src')) {
      $(node).find('video').attr('src', $(node).find('video').attr('data-src'))
    }
  })

  window.MicroBus.on('variant:change', ({ detail }) => {
    const { variant, product, location } = detail
    if (location === 'buybox') return
    const id = Number($(node).attr('data-product-id'))
    const img = $(node).find('img.js-product-card-img')
    if (id === product.id) {
      const { src } = variant.featured_image
      const srcset = `${resizeImageSrc(src, 375)} 375w, 
                      ${resizeImageSrc(src, 425)} 425w, 
                      ${resizeImageSrc(src, 550)} 550w, 
                      ${resizeImageSrc(src, 650)} 650w`

      img.attr('src', resizeImageSrc(src, 650))
      img.attr('srcset', srcset)
    }
  })
})
